import gql from 'graphql-tag';

export const CHECK_IN = gql`
  mutation createCheckIn($data: CheckInCreateInput!){
  createCheckIn(data: $data){
  id
  }
}
`;